import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';
import {memo} from 'react';

const PrinterSettingIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path
        fill={props?.fill || '#5DA9E9'}
        d="M17.012 14.429v-.834l.917-.666c.083-.084.167-.167.083-.25l-.833-1.417c0-.083-.167-.083-.25-.083l-1 .416c-.25-.166-.5-.333-.75-.416l-.167-1.084a.18.18 0 0 0-.166-.166h-1.667c-.167 0-.25.083-.25.166l-.167 1.084c-.25.166-.416.25-.666.416l-1-.416c-.084 0-.167 0-.25.083l-.834 1.417c0 .083 0 .166.084.25l.916.666v.834l-.916.666c-.084.084-.167.167-.084.25l.834 1.417c.083.083.166.083.25.083l1-.416c.166.166.416.333.666.416l.167 1.084c.083.083.167.166.25.166h1.667a.18.18 0 0 0 .166-.166l.167-1.084c.25-.166.417-.25.667-.416l1 .333c.083 0 .166 0 .25-.083l.833-1.417c.083-.083.083-.167 0-.167l-.917-.666Zm-3.083.75c-.667 0-1.25-.584-1.25-1.25 0-.667.583-1.25 1.25-1.25s1.25.583 1.25 1.25c0 .666-.583 1.25-1.25 1.25Zm-10-4.584V8.93h3.333v1.666H3.93Zm-.833-2.5h11.666a1.667 1.667 0 0 0-1.666-1.666h-.834v-5H3.93v5h-.833a1.667 1.667 0 0 0-1.667 1.666v5.834h6.667c0-.575.091-1.142.241-1.667H3.096V8.095Zm2.5-5h5V6.43h-5V3.095Z"
      />
    </Icon>
  );
};

export default memo(PrinterSettingIcon);
